module.exports = __webpack_public_path__ + "static/media/bag.7dee400f.svg";